import { ViteReactSSG } from "vite-react-ssg";
import { routes, getStaticPaths } from "./routes";
import "./index.css";

export const createRoot = ViteReactSSG(
  { routes },
  ({ isClient }) => {
    // Client-side initialization
    if (isClient) {
      import("./utils/visitorTracking").then(({ initVisitorTracking }) => {
        initVisitorTracking();
      });
    }
  }
);

// Export static paths for pre-rendering
export { getStaticPaths };
